import { render, staticRenderFns } from "./generator.active.component.vue?vue&type=template&id=cc3f44be&"
import script from "./generator.active.component.vue?vue&type=script&lang=ts&"
export * from "./generator.active.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports